/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Ft_3_DescInputs */

const en_vc_ft_3_desc = /** @type {(inputs: Vc_Ft_3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editable blend paths with smooth colour, every object as a row in Layers, and stacked fills, strokes and effects.`)
};

const zh_vc_ft_3_desc = /** @type {(inputs: Vc_Ft_3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可编辑的混合路径和平滑过渡色，每个对象都在图层面板中单独一行，填色、描边和效果可以叠加。`)
};

/**
* | output |
* | --- |
* | "Editable blend paths with smooth colour, every object as a row in Layers, and stacked fills, strokes and effects." |
*
* @param {Vc_Ft_3_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_ft_3_desc = /** @type {((inputs?: Vc_Ft_3_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Ft_3_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_ft_3_desc(inputs)
	return zh_vc_ft_3_desc(inputs)
});
export { vc_ft_3_desc as "vc.ft.3.desc" }